import { Typography, Box } from '@mui/material';
import React, { Component } from 'react';
import WidgetCard from './WidgetCard';

class Section extends Component {
  state = {
    fixedWidgetsLength: 0,
    movableWidgetsLength: 0,
  };

  componentDidMount() {
    this.getLengths();
  }

  //θ(N) where N is the number of widgets in a section
  //Calculates the total number of movable and fixed widgets in the section
  getLengths = () => {
    const { fixedWidgetsLength, movableWidgetsLength } = this.props.widgetsOrder.reduce(
      (lengths, widget) => {
        if (widget.isNoDrag) {
          lengths.fixedWidgetsLength += 1;
        } else {
          lengths.movableWidgetsLength += 1;
        }

        return lengths;
      },
      {
        fixedWidgetsLength: 0,
        movableWidgetsLength: 0,
      },
    );

    this.setState({
      fixedWidgetsLength,
      movableWidgetsLength,
    });
  };

  render() {
    const widgets = this.props.widgetsOrder;

    //Moving it to componentDidUpdate would not make much difference as we will have to update it for every reordering.
    //The only place where we would not update is when we change the dnd - keyboard toggle
    const displayWidgets = widgets.filter((widget) => widget.isDisplay);

    return (
      <React.Fragment>
        <div
          style={{
            height: '100%',
          }}
        >
          <Box className="widgetSection" sx={{ p: 1, height: '100%' }}>
            {/* We are getting the section index from props. Using that we are deriving the alphabet using ASCII code */}
            <Typography component="h3">
              Section {String.fromCharCode('A'.charCodeAt(0) + this.props.sectionNumber)}
            </Typography>
            {displayWidgets.map((widget, idx) => {
              return (
                <WidgetCard
                  widget={widget}
                  sectionNumber={this.props.sectionNumber}
                  key={widget.id}
                  moveWidget={this.props.moveWidget}
                  hideUp={
                    widgets?.length - idx === this.state.movableWidgetsLength || widget.isNoDrag
                  }
                  hideDown={idx === displayWidgets.length - 1 || widget.isNoDrag}
                  index={idx - this.state.fixedWidgetsLength}
                />
              );
            })}
          </Box>
        </div>
      </React.Fragment>
    );
  }
}

export default Section;
